import { api } from "@/util/api";

export const getNotifications = async (params = {}) => {
    return api
        .get("notifications", {
            params,
        })
        .then(({ data }) => data);
};

export const getUnreadNotifications = async (params = {}) => {
    return api
        .get("notifications/unread", {
            params,
        })
        .then(({ data }) => data);
};

export const markAsRead = async (id: number, params = {}) => {
    return api
        .post("notifications/" + id, {
            params,
        })
        .then(({ data }) => data);
};

export const markAllAsRead = async (params = {}) => {
    return api
        .post("notifications/read-all", {
            params,
        })
        .then(({ data }) => data);
};
